.controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
  user-select: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.dot::before,
.dot::after {
  content: '';
  position: absolute;
  background: rgba(0, 0, 0, 0.0);
  transition: background 0.1s ease;
}

.controls:hover .dot::before,
.controls:hover .dot::after {
  background: rgba(0, 0, 0, 0.5);
}

.dot[data-color="red"] {
  background: #FF5F57;
}

.dot[data-color="yellow"] {
  background: #FEBC2E;
}

.dot[data-color="green"] {
  background: #28C840;
}

/* Red X icon */
.dot[data-color="red"]::before,
.dot[data-color="red"]::after {
  width: 8px;
  height: 1.5px;
  top: 50%;
  left: 50%;
  border-radius: 1px;
}

.dot[data-color="red"]::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.dot[data-color="red"]::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* Yellow minus icon */
.dot[data-color="yellow"]::before {
  width: 8px;
  height: 1.5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1px;
}

.dot[data-color="yellow"]::after {
  display: none;
}

/* Green plus icon */
.dot[data-color="green"]::before,
.dot[data-color="green"]::after {
  border-radius: 1px;
  top: 50%;
  left: 50%;
}

.dot[data-color="green"]::before {
  width: 8px;
  height: 1.5px;
  transform: translate(-50%, -50%);
}

.dot[data-color="green"]::after {
  width: 1.5px;
  height: 8px;
  transform: translate(-50%, -50%);
}

@media (hover: none) and (pointer: coarse) {
  .controls {
    gap: 12px;
  }

  .dot {
    width: 22px;
    height: 22px;
  }
}
